import { render, staticRenderFns } from "./orderMerge.vue?vue&type=template&id=4e977142&scoped=true"
import script from "./orderMerge.vue?vue&type=script&lang=js"
export * from "./orderMerge.vue?vue&type=script&lang=js"
import style0 from "./orderMerge.vue?vue&type=style&index=0&id=4e977142&prod&scoped=true&lang=css"
import style1 from "./orderMerge.vue?vue&type=style&index=1&id=4e977142&prod&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e977142",
  null
  
)

export default component.exports